mutation CloseTrivia($triviaId: ID!) {
  trivia: StreamToolsCloseTrivia(triviaId: $triviaId) {
    triviaId
    eventId
    name
    broadcasterUserIds
    question
    status
    dedupe
    youtubeVotesEnabled
    totalVotes
    hasYouTubeVotes
    hideLiveResults
    showAnswersCounter
    closeGraceSeconds
    closedAt
    graceEndsAt
    revealedAt
    youtubeCountsPurgedAt
    youtubeFinalAt
    youtubeCountingUntil
    answersIn { twitch youtube }
    startedAt
    stoppedAt
    createdAt
    callToActionText
    headingTextColor
    optionsTextColor
    callToActionTextColor
    headingBackground
    optionsBackground
    callToActionBackground
    alternatingOptionBackground
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    winnerOutlineColor
    fontKey
    questionFontSize
    displayTextFontSize
    commandFontSize
    numberFontSize
    callToActionFontSize
    revealTextFontSize
    version
    options {
      optionId
      displayText
      command
      voteCount
      voteCountByPlatform { twitch youtube }
      textColor
      progressBarColor
      isCorrect
      backgroundColor
    }
  }
}
